import React from 'react';
const facts = [{
  value: '6 + 5',
  label: 'Volumes & bonuses'
}, {
  value: '300+',
  label: 'Pages of planned practices'
}, {
  value: '37',
  label: 'Ready-to-run practices'
}, {
  value: '78',
  label: 'Drills, timed & sequenced'
}];

// Acentos de bloque del producto (Clay / Green / Navy / Gold)
const accents = ['before:bg-clay', 'before:bg-green', 'before:bg-gold', 'before:bg-crimson'];
export function SocialProofBar() {
  return <section className="w-full bg-navy" data-id="element-225" data-mp="32ibki7ul67th">
      <div className="max-w-6xl mx-auto px-5 pb-14 sm:pb-16" data-id="element-226" data-mp="2xji8ykyv0qvy">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-navy-line bg-navy-line sm:grid-cols-4" data-id="element-227" data-mp="2xhxawldc6ptc">
          {facts.map((fact, i) => <div key={fact.label} className={`relative bg-navy px-4 py-5 text-center before:absolute before:inset-x-0 before:top-0 before:h-1 before:content-[''] ${accents[i]}`} data-id="element-228" data-mp="2oik2zx4v29aq" data-mpi={i}>
              <div className="font-display text-3xl sm:text-4xl leading-none text-gold" data-id="element-229" data-mp="1d2vev2fvf48c">
                {fact.value}
              </div>
              <div className="mt-1.5 text-[10px] font-bold uppercase tracking-widest text-white/60" data-id="element-230" data-mp="1dn5lrevertja">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}